import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";

const testimonials = [
  { name: "Sarah K.", role: "Business Owner", text: "Gloogum replaced 5 different tools for me. My business listing gets 10x more visibility now.", rating: 5 },
  { name: "Marcus J.", role: "Freelancer", text: "I found my best clients through Gloogum's freelance marketplace. The escrow system is a game changer.", rating: 5 },
  { name: "Priya M.", role: "Event Planner", text: "The event RSVP and ticketing system is incredibly smooth. My guests love the digital invitation cards.", rating: 5 },
];

const TestimonialsSection = () => {
  return (
    <section className="py-4 md:py-24 bg-muted/30">
      <div className="container px-4">
        <motion.div
          className="text-center mb-4 md:mb-16"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <span className="text-sm font-medium text-primary uppercase tracking-wider">Testimonials</span>
          <h2 className="font-display text-2xl md:text-5xl font-bold mt-2 md:mt-3 mb-2 md:mb-4">
            Loved by <span className="gradient-text">Millions</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((t, i) => (
            <motion.div
              key={t.name}
              className="relative p-8 rounded-2xl bg-card shadow-card"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1 }}
            >
              <Quote className="w-8 h-8 text-primary/20 mb-4" />
              <p className="text-foreground mb-6 leading-relaxed">{t.text}</p>
              <div className="flex items-center gap-1 mb-3">
                {Array.from({ length: t.rating }).map((_, j) => (
                  <Star key={j} className="w-4 h-4 fill-accent text-accent" />
                ))}
              </div>
              <p className="font-display font-semibold">{t.name}</p>
              <p className="text-muted-foreground text-sm">{t.role}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
